module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.module.index.title')))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 16
    }
  }, [_c('div', {
    staticClass: "listOptions pull-right"
  }, [_c('v-text', {
    staticClass: "searchForm",
    attrs: {
      "name": "search",
      "type": "text",
      "translation": "search.title",
      "value": _vm.search
    },
    on: {
      "keydown": _vm.onChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _vm._l((_vm.modulesList), function(mdule) {
    return _c('div', {
      staticClass: "flex stretch wrap"
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', {
      staticClass: "full-w flex wrap client-title-container margin-b-10"
    }, [_c('i', {
      staticClass: "el-icon-news",
      staticStyle: {
        "font-size": "40px",
        "padding-right": "10px"
      }
    }), _vm._v(" "), _c('h2', {
      staticClass: "cardTitle"
    }, [_vm._v(_vm._s(("" + (mdule.group))))])])]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin-bottom": "30px"
      },
      attrs: {
        "span": 24
      }
    }, [_c('div', {
      staticClass: "flex stretch wrap"
    }, _vm._l((mdule.modules), function(p, i) {
      return (p.name != 'Lokalbrygg') ? _c('v-card', {
        key: i,
        attrs: {
          "wide": false
        }
      }, [_c('div', {
        staticClass: "full-w flex wrap client-title-container margin-b-10"
      }, [_c('i', {
        staticClass: "el-icon-news",
        staticStyle: {
          "font-size": "40px",
          "padding-right": "10px"
        }
      }), _vm._v(" "), _c('h2', {
        staticClass: "cardTitle"
      }, [_vm._v(_vm._s(("" + (p.name))))])]), _vm._v(" "), _c('hr'), _vm._v(" "), [_c('span', {
        staticClass: "cardLabel"
      }, [_vm._v(_vm._s(p.description))])], _c('br'), _vm._v(" "), [(p.price) ? _c('span', {
        staticClass: "cardBadge"
      }, [_vm._v("Kr. " + _vm._s(p.price) + " /mnd")]) : _vm._e()], _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), (p.subscribe == 1 && p.disabled == false) ? [_c('label', {
        staticClass: "cardLabel"
      }, [_c('el-button', {
        staticClass: "dark small right",
        attrs: {
          "disabled": p.requested
        },
        on: {
          "click": function($event) {
            return _vm.unsubscribe(p.id)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('button.unsubscribe').toUpperCase()))])], 1)] : _vm._e(), _vm._v(" "), (p.subscribe == 0 && p.disabled == false) ? [_c('label', {
        staticClass: "cardLabel"
      }, [_c('el-button', {
        staticClass: "green small right",
        attrs: {
          "disabled": p.requested
        },
        on: {
          "click": function($event) {
            return _vm.subscribe(p)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('button.subscribe').toUpperCase()))])], 1)] : _vm._e(), _vm._v(" "), (p.subscribe == 1 && p.disabled == false && p.allowUpdate === true) ? [_c('label', {
        staticClass: "cardLabel"
      }, [_c('el-button', {
        staticClass: "green small right",
        attrs: {
          "disabled": p.requested
        },
        on: {
          "click": function($event) {
            return _vm.updateFields(p)
          }
        }
      }, [_vm._v(_vm._s('Update fields'))])], 1)] : _vm._e()], 2) : _vm._e()
    }), 1)])], 1)
  })], 2), _vm._v(" "), _c('el-row', [_c('el-col')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-659b6778","hasScoped":true}!./src/app/pages/withNavigation/modules/index/index.html
// module id = 3041
// module chunks = 1